<template>
  <router-link :to="`${`/topic/${getTopicCode}`}`" class="topic" v-if="data">
    <div v-if="showImage" class="image-container">
      <img :src="showImage" :alt="getName" onerror="this.style.display='none'"/>
    </div>
    <span>{{ getName }}</span>
  </router-link>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default: null
      },
    },
    computed: {
      type() {
        return this.data?.meta?.type || '?';
      },
      showImage() {
        if (this.data?.meta?.type == 'country' || this.data?.type == 'country') {
          // console.log("COUNTRY: ", this.data);
          // let sCode = this.data?.topic_name?.toLowerCase()?.replace(/\s/, '-');
          let sCode = this.data?.topic_code || this.data?.code;
          if (sCode.length == 2) {
            return `https://nourished.news/r/i/icons/country_flags/2020/png-iso/${sCode}.png`;
          }
        }

        const image = this.data.meta?.image || this.data.image;
        
        if (image == 'https://nourished.news') {
          return false;
        }
        if (!image) {
          return false;
        }
        return image;
      },
      getName() {
        return this.data?.meta?.name || this.ucfirst(this.data.topic_name || this.data.name) || this.data.topic_name || this.data.name;
      },

      getTopicCode() {
        return this.data?.topic_code || this.data?.code;
      }
    },
    methods: {
      ucfirst(s) {
        if (!s) {
          return 'xx';
        }
        s.charAt(0).toUpperCase() + s.slice(1);
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .topic {
    display: flex;
    align-items: center;
    justify-content: center;
    // height: 40px;
    height: 2em;
    padding: 0 .75rem;
    border-radius: 500px;
    background: $neutral-500;
    color: $neutral-400;
    cursor: pointer;
    text-transform: capitalize;
    @include transition;

    .darkmode & {
      background: $neutral-300;
    }

    .image-container {
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 0.25rem;
      margin-left: -.5em;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
        // filter: grayscale(100%);
        border: 2px solid transparent;
      }
    }

    span {
      font-size: 0.9rem;
      white-space: nowrap;
      padding-bottom: 1px;
    }

    &:hover {
      background: $yellow-tone-3;
      color: $neutral-100;

      .darkmode & {
        color: $neutral-100;
      }

      span {
        color: $neutral-100;

        .darkmode & {
          color: $neutral-100;
        }
      }

      .image-container img {
        filter: grayscale(0%);
        border: 2px solid white;
      }
    }
  }

  .mq-sm {
    .topic {
      color: $neutral-200;

      .darkmode & {
        color: $neutral-600;
      }

      .image-container img {
        filter: grayscale(0%);
      }
    }
  }
</style>